import React from 'react'
import { CameraProvider } from './cameraContext'
import { DeviceProvider } from './deviceContext'
import { ErrorProvider } from './errorContext'
import { IMConnectionProvider } from './imConnectionContext'

export default function WrapContext(props) {
    return (
        <ErrorProvider {...props}>
            <CameraProvider {...props}>
                <DeviceProvider {...props}>
                    <IMConnectionProvider {...props} />
                </DeviceProvider>
            </CameraProvider>
        </ErrorProvider>
    )
}
